import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      // border: '2px solid red',
      height: 'inherit',
      width: '16.5em',
      // width: '90%',
      margin: '40px 20px 0px 20px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      // overflow: 'auto',
      //   alignItems: 'center',
    },
    text: {
      letterSpacing: '0',
      color: '#6F6F6F',
      marginLeft: '15px',
      fontWeight: '600',
      fontSize: '14px',
    },
    nosites: {
      width: '90%',
      height: '575px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
    },
    nositestext: {
      letterSpacing: '0',
      color: '#939497',
      marginLeft: '15px',
      fontWeight: 'medium',
      fontSize: '20px',
    },
  }),
  { index: 1 },
)

export { useStyles }
